import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { ProjectModel } from '../models/project.model';

@Injectable({
    providedIn: 'root'
})
export class OracleprojectService {
    
    constructor(private apiService: ApiService) { }
    getOracleProjectList(data: any): Observable<ProjectModel> {
        return this.apiService.post('OracleProject/GetOracleProject', data);
    }
}